import { Component, inject, signal } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { TranslateModule } from '@ngx-translate/core';
import { CookiePolicyDialogComponent } from '../cookie-policy-dialog/cookie-policy-dialog.component';
import { LegalLinksComponent } from "../../legal-links/legal-links.component";

@Component({
  selector: 'app-cookie-banner',
  imports: [TranslateModule, LegalLinksComponent],
  templateUrl: './cookie-banner.component.html',
  styleUrl: './cookie-banner.component.scss',
})
export class CookieBannerComponent {
  #dialog = inject(MatDialog);

  private readonly STORAGE_KEY = 'cookieBannerClosed';

   constructor() {
    const closed = sessionStorage.getItem(this.STORAGE_KEY);
    
    if (!closed?.isTruthy()) {
      this.isVisible.set(true);
    }
  }

  isVisible = signal(false);

  openCookiePolicy() {
    this.#dialog.open(CookiePolicyDialogComponent);
  }

  close() {
    sessionStorage.setItem(this.STORAGE_KEY, 'true');
    this.isVisible.set(false);
  }
}
